import Houses from "../Pages/general-pages/Houses";
import Accounts from "../Pages/general-pages/Accounts";
import { LandingPage } from "../Pages/LandingPage";
import Bills from "../Pages/general-pages/Bills";
import Payments from "../Pages/general-pages/Payments";
import MonthlyReport from "../Pages/reports/MonthlyReport";
import AccountsReport from "../Pages/reports/AccountsReport";
import CollectionReport from "../Pages/reports/CollectionReport";
import TermsAndConditions from "../Pages/general-pages/TermsAndConditions";
import NotFound from "../Pages/general-pages/NotFound";
import Users from "../Pages/admin/Users";
import Agents from "../Pages/admin/Agents";
import Dashboard from "../Pages/general-pages/Dashboard";
import AccountDetails from "../Pages/general-pages/Account";
import TransferReport from "../Pages/general-pages/TransferReport";
import Disbursement from "../Pages/general-pages/Disbursement";
import Agent from "../Pages/admin/Agent";
import UserRoles from "../Pages/admin/UserRoles";
import UserGroups from "../Pages/admin/UserGroups";
import ChangePassword from "../Pages/general-pages/ChangePassword";
import SearchAccount from "../Pages/general-pages/SearchAccount";
import CollectionAccounts from "../Pages/admin/CollectionAccounts";
import Reconciliation from "../Pages/general-pages/Reconciliation";
import ReconciliationAction from "../Pages/general-pages/ReconciliationAction";
import Complaints from "../Pages/general-pages/Complaints";
import AccountPendingApproval from "../Pages/general-pages/AccountPendingApproval";
import MonthlyPayments from "../Pages/general-pages/payments/MonthlyPayment";
import DailyPayments from "../Pages/general-pages/payments/DailyPayments";
import PaidAccounts from "../Pages/general-pages/accounts/PaidAccounts";
import UnPaidAccounts from "../Pages/general-pages/accounts/UnpaidAccounts";
import PendingAccounts from "../Pages/general-pages/accounts/PendingAccounts";
import UnPaidAccountsThisMonth from "../Pages/general-pages/accounts/UnPaidAccountsThisMonth";
import AllAccounts from "../Pages/general-pages/accounts/AllAccounts";
import TopDashboard from "../Pages/general-pages/TopDashboard.js";
import ReceiptVerification from "../Component/ReceiptVerification.js";
import InvoiceVerification from "../Component/bills/InvoiceVerification.js";
import Videos from "../Pages/general-pages/Videos.js";
import Support from "../Pages/general-pages/Support.js";
import TopLevelDisbursement from "../Pages/general-pages/TopLevelDisbursement.js";
import Audits from "../Pages/general-pages/Audits.js";

export {
  Houses,
  Accounts,
  LandingPage,
  Bills,
  Payments,
  MonthlyReport,
  AccountsReport,
  CollectionReport,
  TermsAndConditions,
  NotFound,
  Users,
  Agents,
  Dashboard,
  AccountDetails,
  TransferReport,
  Disbursement,
  Agent,
  UserRoles,
  UserGroups,
  ChangePassword,
  SearchAccount,
  CollectionAccounts,
  Reconciliation,
  ReconciliationAction,
  Complaints,
  AccountPendingApproval,
  MonthlyPayments,
  DailyPayments,
  PaidAccounts,
  UnPaidAccounts,
  PendingAccounts,
  UnPaidAccountsThisMonth,
  AllAccounts,
  TopDashboard,
  ReceiptVerification,
  InvoiceVerification,
  Videos,
  Support,
  TopLevelDisbursement,
  Audits,
};